<div class="dialog">
  <div class="close-dialog" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </div>
  <div class="flex flex__align-items--center flex--column">
    <h3 textWeight="bold" textColor="black-two">Create Trip</h3>
  
    <form [formGroup]="dataForm" class="forgot-password__form flex flex--column flex--box">
      <ng-select placeholder="Select dispatcher" [virtualScroll]="true" formControlName="dispatcherId"
        (scrollToEnd)="getListDispatchers()" *ngIf="currentUser.roleId !== roles.DISPATCHER">
        <ng-option *ngFor="let dispatcher of dispatchers" [value]="dispatcher.id">{{dispatcher.firstName}}
          {{dispatcher.lastName}}</ng-option>
      </ng-select>
  
      <ng-select placeholder="Select driver" [virtualScroll]="true" formControlName="driverId"
        (scrollToEnd)="getListDrivers()">
        <ng-option *ngFor="let driver of drivers" [disabled]="isDriverUnavailable(driver)" [value]="driver.id">{{driver.firstName}} {{driver.lastName}}</ng-option>
      </ng-select>

      <button mat-raised-button (click)="inviteDriver()">Invite Driver</button>
    </form>
  
    <div md-dialog-actions class="actions flex">
      <button class="actions--button flex--box" mat-raised-button color="warn" (click)="createTrip(false)">Create as Draft</button>
      <button class="actions--button flex--box" mat-raised-button color="primary" (click)="createTrip(true)">Send to Driver</button>
    </div>
  </div>
</div>
